"use client"
import { useEffect } from "react"

type Props = {
  hideHeaderFooter: boolean
  children: React.ReactNode
}

/**
 * Manages header/footer visibility for project pages.
 * Injects an inline blocking script that runs BEFORE React hydration.
 * This prevents any flash of header/footer on initial page load.
 */
export default function ProjectLayoutManager({ hideHeaderFooter, children }: Props) {
  useEffect(() => {
    // Ensure the class is set/removed on client-side navigation
    if (hideHeaderFooter) {
      document.body.classList.add("no-layout")
    } else {
      document.body.classList.remove("no-layout")
    }

    return () => {
      document.body.classList.remove("no-layout")
    }
  }, [hideHeaderFooter])

  return (
    <>
      {hideHeaderFooter && (
        <script
          dangerouslySetInnerHTML={{
            __html: `(function(){document.body.classList.add('no-layout');})();`,
          }}
        />
      )}
      {children}
    </>
  )
}
